import { RecordFolderAssignment } from '@provision/entity-types';
import { RecordFolderRaw } from 'src/types';

// using enum to be able to extend it with options in the future,
// technically for 2 options we could use boolean, but there are some plans to add more
// like disabled, snoozed etc.
export enum RecordFolderVisibility {
  Shown = 'shown',
  Hidden = 'hidden',
}

export enum RecordFolderArea {
  View = 'view',
  Actions = 'actions',
}

export type RecordFolder = Omit<
  RecordFolderRaw,
  'labelAssignments' | 'partner' | 'platformUser' | 'recordFolderAssignments'
> & {
  visibility?: RecordFolderVisibility;
  assignments?: RecordFolderAssignment[];
  area?: RecordFolderArea;
};
